import axios from 'axios';
import qs from 'qs';

export default {
    name: 'login-form',
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        alert: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            username: '',
            password: '',
            buttonClasses: ['is-fullwidth'],
            loadingState: false
        };
    },
    computed: {
        // Enable button if username & password have a value
        isCompleted() {
            return this.username && this.password;
        }
    },
    // Methods needed for this component.
    methods: {
        // Submit request for v2 login.
        v2Login(data) {
            return axios.post('/login_handler.php', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        },
        // Submit request for v3 login.
        v3Login(data) {
            return axios.post(`${process.env.VUE_APP_QV3_API}/login`, data);
        },
        // Submit request for v4 login.
        v4Login(data) {
            return axios.post(
                `${process.env.VUE_APP_QV4_API}/users/login`,
                data
            );
        },
        // Submit form event.
        onSubmit() {
            // Add the loading spinner icon to the button.
            this.loadingState = true;

            // Reset any alerts previously displayed.
            this.$emit('currentAlert', null);

            // Add the loading spinner icon to the button.
            this.buttonClasses.push('button-loading');

            // Set data object(s) for ajax requests.
            // gsData is formatted as form data rather than json.
            let data = {
                    username: this.username,
                    password: this.password,
                    login: 'Sign In'
                },
                qsData = qs.stringify(data);

            axios
                .all([
                    this.v2Login(qsData),
                    this.v3Login(data),
                    this.v4Login(data)
                ])
                .then(
                    axios.spread((v2Data, v3Data, v4Data) => {
                        // Reset login attempts with successfull login
                        window.localStorage.setItem('locked', false);

                        // For impersonation, remove @ when storing username in localStorage
                        data.username =
                            data.username.charAt(0) == '@'
                                ? data.username.substr(1)
                                : data.username;

                        // Create authenticated object which is used on some v3 api calls
                        let auth = {
                            user: {
                                id: v4Data.data.userId,
                                username: data.username
                            },
                            v3: {
                                url: process.env.VUE_APP_QV3_API,
                                token: v3Data.data.data.token
                            },
                            v4: {
                                url: process.env.VUE_APP_QV4_API,
                                token: v4Data.data.token
                            }
                        };

                        // Set authenticated in browser local storage.
                        window.localStorage.setItem(
                            'authenticated',
                            JSON.stringify(auth)
                        );

                        if (v4Data.data.signedJWT) {
                            var token = v4Data.data.signedJWT;
                            var domain = process.env.VUE_APP_COOKIE_DOMAIN;
                            var d = new Date();
                            d.setTime(d.getTime() + (8*24*60*60*1000)); // Expires in 8 days
                            var expires = "expires="+ d.toUTCString();
                            document.cookie = 'QV2Auth=' + token + '; ' + expires + '; domain=' + domain + '; path=/';
                        }

                        // Remove the loading spinner icon from button, and show success icon.
                        let index = this.buttonClasses.indexOf(
                            'button-loading'
                        );
                        let redirectUrl;

                        if (index > -1) {
                            this.buttonClasses.splice(index, 1);
                        }

                        this.buttonClasses.push('button-success');

                        // If they are a corporate user.
                        if (v4Data.data.agreementId && !this.isMobile) {
                            redirectUrl = '/corporateportal/reports.php';

                            // If there is a redirect param in the url.
                        } else if (this.$parent.redirect) {
                            redirectUrl = '/' + this.$parent.redirect;

                            // If it's mobile.
                        } else if (this.isMobile) {
                            redirectUrl = '/mobile/profile.php';

                            // Anything else.
                        } else {
                            redirectUrl = '/dashboard.php';
                        }

                        // Redirect to dashboard after successful login.
                        window.location.href = redirectUrl;
                    })
                )
                // If login failed.
                .catch(err => {
                    // Remove loading spinner on button
                    this.loadingState = false;

                    let logoutUrl = this.isMobile
                        ? '/mobile/logout.php'
                        : '/logout.php';

                    axios.post(logoutUrl);

                    // Set alert data.
                    let alert = {
                            message: this.$t('HC_FAILED_LOGIN'),
                            status: 'danger',
                            icon: 'exclamation-circle-outline'
                        },
                        index = this.buttonClasses.indexOf('button-loading');

                    // Remove loading spinner icon from button.
                    if (index > -1) {
                        this.buttonClasses.splice(index, 1);
                    }

                    // If they've attempted 9 times, this is their 10th, so send to locked page.
                    if (err.response.status === 429) {
                        // Set incremented login attempts in local storage.
                        this.$emit('currentView', 'locked');
                        this.$emit(
                            'currentTransition',
                            'component-slide-fade-up'
                        );
                        this.$emit('currentAlert', null);

                        // Send alert data to parent component.
                    } else {
                        this.$emit('currentAlert', alert);
                    }
                });
        },
        // Handle button state based on username and password being populated.
        onChangeInputField() {
            // Validate Username
            let validUsername = this.username;

            // Validate Password
            let validPassword = this.password;

            this.isCompleted = validUsername && validPassword;
        },
        // Click event for the forgot password link.
        onClickForgotPassword(e) {
            e.preventDefault();
            this.$emit('currentView', 'forgot-password');
            this.$emit('currentTransition', 'component-slide-fade-up');
            this.$emit('currentAlert', null);
        },
        // Transition to Support component on Forgot Quore ID click.
        onClickForgotQuoreID(e) {
            e.preventDefault();
            this.$emit('currentView', 'support');
            this.$emit('currentStatus', 'quoreid');
            this.$emit('currentTransition', 'component-slide-fade-up');
            this.$emit('currentAlert', null);
        }
    }
};
